import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MessageCircle, Bot, Settings, Phone, Globe, Smartphone, BarChart, Info, AlertTriangle, Server } from 'lucide-react';
type PriceItem = {
  name: string;
  price: string;
  examples?: string[];
  isFree?: boolean;
};
type PriceCategory = {
  title: string;
  icon: React.ElementType;
  items: PriceItem[];
  warning?: string;
};
const pricingData: PriceCategory[] = [{
  title: 'Domeniu Propriu & Găzduire Website (Romarg)',
  icon: Server,
  items: [{
    name: 'Domeniu .ro (ex: numeletau.ro)',
    price: '€8.99 + TVA 21% / an',
    examples: ['€8.99 + €1.89 TVA = €10.88 / an']
  }, {
    name: 'Găzduire website — preț fix pe viață',
    price: '€5 / lună (fără TVA)',
    examples: ['€5 × 12 luni = €60 / an']
  }, {
    name: 'Total anual (domeniu + găzduire)',
    price: '€70.88 / an',
    examples: ['Domeniu €10.88 + Găzduire €60.00 = €70.88 / an']
  }],
  warning: '⚠️ Recomandare importantă: Nu lăsați niciodată achiziția domeniului pe seama unei agenții. Dacă agenția cumpără domeniul în numele ei, ea devine proprietarul legal al acestuia — nu dumneavoastră. Asta înseamnă că, în cazul unei neînțelegeri sau al încetării colaborării, riscați să pierdeți accesul la propriul website și implicit la întreaga prezență online a afacerii. Cumpărați întotdeauna domeniul pe numele dumneavoastră, direct de la un registrar de încredere precum Romarg.'
}, {
  title: 'Email Marketing',
  icon: Mail,
  items: [{
    name: 'Email (trimitere)',
    price: '$0.00108 / email',
    examples: ['1,000 emailuri ≈ $1.08', '10,000 emailuri ≈ $10.80', '100,000 emailuri ≈ $108']
  }, {
    name: 'LC Email Verification',
    price: '$0.004 / verificare',
    examples: ['1,000 verificări ≈ $4', '10,000 verificări ≈ $40']
  }, {
    name: 'Dedicated IP',
    price: '$88.50 / lună'
  }]
}, {
  title: 'WhatsApp',
  icon: MessageCircle,
  items: [{
    name: 'WhatsApp (abonament lunar)',
    price: '$18 / lună'
  }, {
    name: 'WhatsApp Usage (pe mesaj)',
    price: '$0.1184 / mesaj',
    examples: ['100 mesaje ≈ $11.84', '500 mesaje ≈ $59.20', '1,000 mesaje ≈ $118.40']
  }]
}, {
  title: 'AI & Agenți',
  icon: Bot,
  items: [{
    name: 'AI Employee',
    price: '$127 / lună'
  }, {
    name: 'Conversation and Voice AI',
    price: '$0.032 / mesaj · $0.208 / min voice',
    examples: ['100 mesaje ≈ $3.20 · 1,000 mesaje ≈ $32', '60 min voice ≈ $12.48 · 100 min voice ≈ $20.80']
  }, {
    name: 'Agent Studio',
    price: '$0.40 / 750,000 cuvinte',
    examples: ['10,000 cuvinte ≈ $0.005 (foarte ieftin)']
  }, {
    name: 'Content AI',
    price: '$0.144 / 1000 cuvinte · $0.096 / imagine',
    examples: ['10,000 cuvinte ≈ $1.44', '100 imagini ≈ $9.60']
  }, {
    name: 'Reviews AI',
    price: '$0.016 / răspuns review',
    examples: ['100 review-uri ≈ $1.60 · 1,000 review-uri ≈ $16']
  }, {
    name: 'Funnel AI',
    price: '$1.584 / funnel',
    examples: ['10 funnels ≈ $15.84']
  }]
}, {
  title: 'Workflow & Automatizări',
  icon: Settings,
  items: [{
    name: 'Workflow Pro – Starter Tier',
    price: '$15 / lună'
  }, {
    name: 'Workflow Pro – Growth Tier',
    price: '$30 / lună'
  }, {
    name: 'Workflow Pro – Scale Tier',
    price: '$60 / lună'
  }, {
    name: 'Workflow Premium Features',
    price: '$0.016 / execuție',
    examples: ['100 execuții ≈ $1.60 · 1,000 execuții ≈ $16']
  }, {
    name: 'Workflow External AI Models (Input)',
    price: '$0.96 / 750,000 cuvinte'
  }, {
    name: 'Workflow External AI Models (Output)',
    price: '$3.84 / 750,000 cuvinte'
  }]
}, {
  title: 'Telefonie (Phone System – Twilio US)',
  icon: Phone,
  items: [{
    name: 'Apeluri efectuate',
    price: '$0.0224 / minut',
    examples: ['100 min ≈ $2.24 · 1,000 min ≈ $22.40']
  }, {
    name: 'Apeluri primite',
    price: '$0.0136 / minut',
    examples: ['100 min ≈ $1.36 · 1,000 min ≈ $13.60']
  }, {
    name: 'SMS',
    price: '$0.01328 / segment',
    examples: ['100 SMS ≈ $1.33 · 1,000 SMS ≈ $13.28']
  }]
}, {
  title: 'Web & Hosting',
  icon: Globe,
  items: [{
    name: 'WordPress',
    price: '$14.99 / lună'
  }, {
    name: 'Domain Purchase',
    price: '$16 / domeniu'
  }, {
    name: 'SEO (by Search Atlas)',
    price: '$97 / lună'
  }]
}, {
  title: 'Produse cu Abonament',
  icon: Smartphone,
  items: [{
    name: 'Branded Client Portal Mobile App',
    price: '$79 / lună'
  }, {
    name: 'Listings – Monthly Plan',
    price: '$49 / lună'
  }, {
    name: 'Listings – Smart Saver',
    price: '$200 / 6 luni'
  }, {
    name: 'Listings – Annual Advantage',
    price: '$450 / an'
  }, {
    name: 'Prospecting',
    price: '$45 / lună'
  }]
}, {
  title: 'Ads & Marketing',
  icon: BarChart,
  items: [{
    name: 'Ad Manager',
    price: 'Gratuit / neconfigurat',
    isFree: true
  }]
}];
export function PriceList() {
  return <section className="py-16 md:py-24 px-6 bg-bg-surface min-h-screen" data-id="element-229">
      <div className="max-w-4xl mx-auto" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-soft overflow-hidden border border-border-light" data-id="element-231">
          {/* Header */}
          <div className="bg-accent-navy py-8 px-8 md:px-12 text-center" data-id="element-232">
            <h1 className="font-bebas text-4xl md:text-5xl uppercase text-white tracking-wide" data-id="element-233">
              Lista Prețuri – Servicii Adiționale
            </h1>
          </div>

          <div className="p-6 md:p-12" data-id="element-234">
            {/* Notice Box */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-blue-50 border-l-4 border-accent-blue p-5 rounded-r-lg mb-12 flex gap-4 items-start" data-id="element-235">
              <Info className="w-6 h-6 text-accent-blue flex-shrink-0 mt-0.5" data-id="element-236" />
              <div data-id="element-237">
                <strong className="block font-jakarta text-accent-navy font-bold mb-1" data-id="element-238">
                  Important de știut
                </strong>
                <p className="font-jakarta text-sm md:text-base text-accent-navy/80 leading-relaxed" data-id="element-239">
                  Acestea sunt servicii adiționale care pot fi cumpărate
                  separat, în afara abonamentului la platforma{' '}
                  <strong className="font-bold" data-id="element-240">Comunități Online</strong>.
                  Niciunul dintre ele nu este obligatoriu, așa că fiecare
                  persoană decide ce costuri vrea să aloce pentru servicii
                  adiționale sau dacă nu vrea să aloce deloc.
                </p>
              </div>
            </motion.div>

            {/* Categories */}
            <div className="space-y-10" data-id="element-241">
              {pricingData.map((category, categoryIndex) => {
              const Icon = category.icon;
              return <motion.div key={categoryIndex} initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true,
                margin: '-50px'
              }} transition={{
                duration: 0.4,
                delay: 0.1
              }} data-id="element-242">
                    <div className="flex items-center gap-3 mb-4 bg-bg-surface p-3 rounded-lg border border-border-light" data-id="element-243">
                      <div className="bg-white p-2 rounded-md shadow-sm" data-id="element-244">
                        <Icon className="w-5 h-5 text-accent-navy" data-id="element-245" />
                      </div>
                      <h2 className="font-jakarta font-bold text-lg md:text-xl text-text-primary" data-id="element-246">
                        {category.title}
                      </h2>
                    </div>

                    <ul className="space-y-2" data-id="element-247">
                      {category.items.map((item, itemIndex) => <li key={itemIndex} className="flex flex-col sm:flex-row sm:items-start justify-between gap-2 sm:gap-6 p-4 rounded-lg hover:bg-bg-surface/50 transition-colors border border-transparent hover:border-border-light" data-id="element-248">
                          <span className="font-jakarta text-base text-text-primary font-medium flex-1" data-id="element-249">
                            {item.name}
                          </span>
                          <div className="sm:text-right flex-shrink-0" data-id="element-250">
                            <span className={`font-jakarta text-base font-bold block ${item.isFree ? 'text-text-secondary italic' : 'text-accent-green'}`} data-id="element-251">
                              {item.price}
                            </span>
                            {item.examples && <div className="mt-1.5 space-y-0.5" data-id="element-252">
                                {item.examples.map((example, i) => <span key={i} className="block font-jakarta text-xs md:text-sm text-text-secondary" dangerouslySetInnerHTML={{
                          __html: example.replace(/(\d+(?:,\d+)*.*?≈.*?(?:\$|€)?\d+(?:\.\d+)?)/g, '<b class="text-accent-navy/70">$1</b>')
                        }} data-id="element-253" />)}
                              </div>}
                          </div>
                        </li>)}
                    </ul>

                    {category.warning && <div className="mt-4 bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg flex gap-3 items-start" data-id="element-254">
                        <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-255" />
                        <p className="font-jakarta text-sm text-amber-900 leading-relaxed" data-id="element-256">
                          {category.warning}
                        </p>
                      </div>}
                  </motion.div>;
            })}
            </div>

            {/* Footer Note */}
            <div className="mt-12 pt-8 border-t border-border-light text-center" data-id="element-257">
              <p className="font-jakarta text-sm text-text-secondary" data-id="element-258">
                Prețurile sunt orientative și pot varia în funcție de utilizare
                și regiune. Calculele sunt estimative pentru referință rapidă.
              </p>
              <p className="font-jakarta text-sm text-text-secondary mt-3 font-semibold" data-id="element-259">
                ⚠️ Important: Prețurile pot fi modificate în orice moment, în
                funcție de actualizările furnizorilor de la care achiziționăm
                aceste servicii sau de alte circumstanțe independente de voința
                noastră. În cazul oricărei modificări de preț, fiecare client va
                fi informat în prealabil prin email.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}